import React from 'react';
import { useSelector } from 'react-redux';
import { BodyText } from '@minerva-analytics/pantheon';
import SubscribeForm from '../../components/SubscribeForm';
import SubscribeJump from '../../components/SubscribeJump';
import MainGraphic from '../../assets/MainGraphic.png';

import {
  HeroContainer,
  HomeContainer,
  ImageContainer,
  HomeTitle,
  HomeImage
} from './Home.styles';

const Home = () => {
  const status = useSelector(
    (state) => state.subscription.createSubscriberStatus,
  );
  const success = status.loaded && !status.failed;
  return (
    <HomeContainer>
      <HeroContainer>
        {success ? <SubscribeJump /> : 
        <>
          <HomeTitle>Daily Science Facts & Trivia</HomeTitle>
          <BodyText>Are you ready to learn something new every day? The Daily Atom delivers interesting science facts, trivia, and history right to your inbox each day. It’s a great way to expand your knowledge of the world around you. You can use these science facts as a conversation starter with your loved ones or just enjoy learning some new science trivia on your own! The Daily Atom is completely free – simply sign up below and we’ll send a new science fact or piece of science trivia to your inbox every day!</BodyText>
          <SubscribeForm />
        </>
        }
      </HeroContainer>
      <ImageContainer>
        <HomeImage src={MainGraphic} />
      </ImageContainer>
    </HomeContainer>
  );
};

export default Home;
